import { useContext } from "react"
import { Outlet } from "react-router";
import NoPermission from "../components/ui/NoPermission";
import AdminSidebar from "../pages/Admin/components/AdminSidebar";
import { CourseProvider } from '../contexts/CourseContext';
import { AnalyticsProvider } from "../contexts/AnalyticsContext";
import { AuthContext } from "../contexts/authContext";

function AdminLayout() {
  const { user } = useContext(AuthContext);

  return (
    user?.is_admin ?
      <AnalyticsProvider>
        <CourseProvider>
        <AdminSidebar>
          <Outlet />
        </AdminSidebar>
        </CourseProvider>
      </AnalyticsProvider>
      :
      <NoPermission />
  )
}

export default AdminLayout